<app-modal
  [title]="'Package selection'| trans:'package-selection-modal/header/title'"
  maxWidth="627px"
>
<ng-container modal-precontent>
  <div class="d-flex align-items-center gap-8 p1">
    <p>
      {{ 'Reihe' | trans:'package-selection-modal/row.Text' }} {{ currentValue?.rankToken }} {{ 'Sitz' | trans:'package-selection-modal/seat.Text' }} {{ currentValue?.seatNumber }}
    </p>
  </div>
</ng-container>
  <ng-template>
    <app-package-selection
      [packages]="seatPackages"
      (packageSelected)="onPackageSelected($event)"
    />
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="onAbort.emit(data); close()"
      >
        {{ 'Cancel'| trans:'kiosk/package-selection-modal/cancel.Button' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase"
        [disabled]="!selectedPackage"
        (click)="selectPackage()"
      >
        {{ 'Confirm'| trans:'package-selection-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-package-products-selection-modal
  [shouldAddToCart]="false"
  (packageConfirmed)="onPackageProductsConfirmed($event)"
/>
